import { useState } from "react";
import Header from "../../components/feature/Header";
import Footer from "../../components/feature/Footer";
import Button from "../../components/base/Button";
import Card from "../../components/base/Card";
import Rendering18 from "@/assets/images/3D/1.png";
import Rendering17 from "@/assets/images/3D/2.jpg";
import Rendering16 from "@/assets/images/3D/3.jpg";
import Rendering15 from "@/assets/images/3D/4.jpg";
import Rendering5 from "@/assets/images/3D/5.jpg";
import Rendering6 from "@/assets/images/3D/6.png";
import Rendering1 from "@/assets/images/3D/7.png";
import Rendering8 from "@/assets/images/3D/8.png";
import Rendering9 from "@/assets/images/3D/9.png";
import Rendering10 from "@/assets/images/3D/10.png";
import Rendering11 from "@/assets/images/3D/11.png";
import Rendering12 from "@/assets/images/3D/12.png";
import Rendering13 from "@/assets/images/3D/13.png";
import Rendering7 from "@/assets/images/3D/3d15.png";
import Rendering2 from "@/assets/images/3D/3d16.png";
import Rendering3 from "@/assets/images/3D/3d17.png";
import Rendering4 from "@/assets/images/3D/3d18.png";
import FlooPlan1 from "@/assets/images/floorplan/1.png";
import FlooPlan2 from "@/assets/images/floorplan/2.png";
import FlooPlan3 from "@/assets/images/floorplan/3.png";
import FlooPlan4 from "@/assets/images/floorplan/4.png";
import FlooPlan5 from "@/assets/images/floorplan/5.png";
import FlooPlan6 from "@/assets/images/floorplan/6.png";
import FlooPlan7 from "@/assets/images/floorplan/7.png";
import FlooPlan8 from "@/assets/images/floorplan/8.png";
import FlooPlan9 from "@/assets/images/floorplan/9.png";
import FlooPlan10 from "@/assets/images/floorplan/10.png";
import Lighting1 from "@/assets/images/lighting/1.png";
import Lighting2 from "@/assets/images/lighting/2.png";
import Lighting3 from "@/assets/images/lighting/3.png";
import Lighting4 from "@/assets/images/lighting/4.png";
import Lighting5 from "@/assets/images/lighting/5.png";
import Lighting6 from "@/assets/images/lighting/6.png";
import Lighting7 from "@/assets/images/lighting/7.png";
import LineDiagram1 from "@/assets/images/linediagram/1.png";
import LineDiagram2 from "@/assets/images/linediagram/2.png";
import Wifi1 from "@/assets/images/wifi/1.png";
import Wifi2 from "@/assets/images/wifi/2.png";
import Wifi3 from "@/assets/images/wifi/3.png";

import Project1Image from "@/assets/images/1-1Remodel.png";
import Project2Image from "../../assets/images/2Landscape Lighting.png";
import HeroImage from "@/assets/images/portfolio_hero.jpg";
import PortfolioSectionA from "../home/components/PortfolioSectionA";
import ServicesShowcaseSection from "./components/ServicesShowcaseSection";

// ─── Types ────────────────────────────────────────────────────────────────────
type ProjectType = "image" | "pdf" | "video" | "rendering360";

interface BaseProject {
  id: number;
  category: string;
  type: ProjectType;
  disclaimer?: {
    label: string;
    description: string;
  };
}
interface ImageProject extends BaseProject {
  type: "image";
  image: string;
}
interface PdfProject extends BaseProject {
  type: "pdf";
  thumbnail: string;
  pdfUrl: string;
  title: string;
}
interface VideoProject extends BaseProject {
  type: "video";
  thumbnail: string;
  videoUrl: string;
  title: string;
}
interface Rendering360Project extends BaseProject {
  type: "rendering360";
  image: string; // card background
  title: string;
  views: {
    south: string;
    north: string;
    west: string;
    east: string;
  };
}
type Project = ImageProject | PdfProject | VideoProject | Rendering360Project;

type ViewDirection = "south" | "north" | "west" | "east";

// ─── Component ────────────────────────────────────────────────────────────────
export default function PortfolioPage() {
  const [serviceType, setServiceType] = useState<"drafting" | "takeoff">("drafting");
  const [activeFilter, setActiveFilter] = useState("All");
  const [selectedProject, setSelectedProject] = useState<number | null>(null);
  const [selectedPdf, setSelectedPdf] = useState<PdfProject | null>(null);
  const [selectedVideo, setSelectedVideo] = useState<VideoProject | null>(null);
  const [selected360, setSelected360] = useState<Rendering360Project | null>(null);
  const [active360Tab, setActive360Tab] = useState<ViewDirection>("south");

  const draftingCategories = [
    "All",
    "Lighting Design & Analysis",
    "Wifi-Lighting Design",
    "3D Visualization & Renderings",
    "Floor Plans",
    "Line Diagrams",
  ];

  const takeoffCategories = [
    "All",
    "Material Takeoff",
    "Labor Estimation",
    "Cost Analysis",
  ];

  // ── Drafting Portfolio ────────────────────────────────────────────────────
  const draftingProjects: Project[] = [
    { id: 1, category: "3D Visualization & Renderings", type: "image", image: Rendering7, disclaimer: { label: "For Reference", description: "This rendering is for illustrative purposes only. Final output may differ based on project specifications and client requirements." } },
    { id: 2, category: "Floor Plans", type: "image", image: FlooPlan4 },
    { id: 3, category: "Lighting Design & Analysis", type: "image", image: Lighting3, disclaimer: { label: "Sample Work", description: "This is a sample lighting analysis. Actual analysis values depend on site-specific conditions, fixture selection, and project scope." } },
    { id: 4, category: "Wifi-Lighting Design", type: "image", image: Wifi1, disclaimer: { label: "Indicative", description: "Wi-Fi coverage shown is indicative. Actual performance depends on hardware, building materials, and environmental factors." } },
    { id: 5, category: "3D Visualization & Renderings", type: "image", image: Rendering11 },
    { id: 6, category: "Line Diagrams", type: "image", image: LineDiagram1 },
    { id: 7, category: "Floor Plans", type: "image", image: FlooPlan2 },
    { id: 8, category: "Lighting Design & Analysis", type: "image", image: Lighting6, disclaimer: { label: "Sample Work", description: "This is a sample lighting analysis. Actual analysis values depend on site-specific conditions, fixture selection, and project scope." } },
    { id: 9, category: "Lighting Design & Analysis", type: "image", image: Project1Image },
    { id: 10, category: "3D Visualization & Renderings", type: "image", image: Rendering3, disclaimer: { label: "For Reference", description: "This rendering is for illustrative purposes only. Final output may differ based on project specifications and client requirements." } },
    { id: 11, category: "Floor Plans", type: "image", image: FlooPlan7 },
    { id: 12, category: "Lighting Design & Analysis", type: "image", image: Lighting4 },
    { id: 13, category: "3D Visualization & Renderings", type: "image", image: Rendering1 },
    { id: 14, category: "Floor Plans", type: "image", image: FlooPlan5 },
    { id: 15, category: "Lighting Design & Analysis", type: "image", image: Lighting5 },
    { id: 16, category: "Floor Plans", type: "image", image: FlooPlan9 },
    { id: 17, category: "Wifi-Lighting Design", type: "image", image: Wifi3 },
    { id: 18, category: "3D Visualization & Renderings", type: "image", image: Rendering10 },
    { id: 19, category: "Lighting Design & Analysis", type: "image", image: Project2Image },
    { id: 20, category: "Floor Plans", type: "image", image: FlooPlan6 },
    { id: 21, category: "Line Diagrams", type: "image", image: LineDiagram2 },
    { id: 22, category: "3D Visualization & Renderings", type: "image", image: Rendering5 },
    { id: 23, category: "Lighting Design & Analysis", type: "image", image: Lighting1 },
    { id: 24, category: "3D Visualization & Renderings", type: "image", image: Rendering12 },
    { id: 25, category: "Floor Plans", type: "image", image: FlooPlan1 },
    { id: 26, category: "3D Visualization & Renderings", type: "image", image: Rendering13 },
    { id: 27, category: "Lighting Design & Analysis", type: "image", image: Lighting7 },
    { id: 28, category: "3D Visualization & Renderings", type: "image", image: Rendering6 },
    { id: 29, category: "3D Visualization & Renderings", type: "image", image: Rendering2 },
    { id: 30, category: "3D Visualization & Renderings", type: "image", image: Rendering4 },
    { id: 31, category: "Floor Plans", type: "image", image: FlooPlan10 },
    { id: 32, category: "Wifi-Lighting Design", type: "image", image: Wifi2 },
    { id: 33, category: "Lighting Design & Analysis", type: "image", image: Lighting2 },
    { id: 34, category: "3D Visualization & Renderings", type: "image", image: Rendering9 },
    { id: 35, category: "3D Visualization & Renderings", type: "image", image: Rendering8 },
    { id: 36, category: "Floor Plans", type: "image", image: FlooPlan3 },
    { id: 37, category: "Floor Plans", type: "image", image: FlooPlan8 },
    { id: 38, category: "3D Visualization & Renderings", type: "image", image: Rendering11 },
    { id: 39, category: "3D Visualization & Renderings", type: "image", image: Rendering15 },
    { id: 40, category: "3D Visualization & Renderings", type: "image", image: Rendering16 },
    { id: 41, category: "3D Visualization & Renderings", type: "image", image: Rendering17 },
    { id: 42, category: "3D Visualization & Renderings", type: "image", image: Rendering18 },
    // PDF samples
    { id: 43, category: "Floor Plans", type: "pdf", title: "Floor Plan – Sample Project", thumbnail: FlooPlan1, pdfUrl: "https://www.w3.org/WAI/WCAG21/Techniques/pdf/PDF2.pdf" },
    { id: 44, category: "Lighting Design & Analysis", type: "pdf", title: "Lighting Analysis Report", thumbnail: Lighting1, pdfUrl: "https://www.w3.org/WAI/WCAG21/Techniques/pdf/PDF2.pdf" },
    // Video samples
    { id: 47, category: "3D Visualization & Renderings", type: "video", title: "3D Walkthrough – Residential Project", thumbnail: Rendering7, videoUrl: "https://www.w3schools.com/html/mov_bbb.mp4" },
    { id: 48, category: "Floor Plans", type: "video", title: "Floor Plan Walkthrough", thumbnail: FlooPlan1, videoUrl: "https://www.w3schools.com/html/mov_bbb.mp4" },
    // 360° samples
    { id: 45, category: "3D Visualization & Renderings", type: "rendering360", title: "Residential Project – 360° Views", image: Rendering7, views: { south: Rendering7, north: Rendering2, west: Rendering3, east: Rendering4 } },
    { id: 46, category: "3D Visualization & Renderings", type: "rendering360", title: "Commercial Build – 360° Views", image: Rendering1, views: { south: Rendering1, north: Rendering8, west: Rendering9, east: Rendering10 } },
  ];

  // ── Takeoff Portfolio ─────────────────────────────────────────────────────
  // Add your real takeoff project images/PDFs/videos here.
  // These are placeholder samples using existing assets.
  const takeoffProjects: Project[] = [
    { id: 101, category: "Material Takeoff", type: "image", image: FlooPlan1 },
    { id: 102, category: "Material Takeoff", type: "image", image: FlooPlan2 },
    { id: 103, category: "Labor Estimation", type: "image", image: FlooPlan3 },
    { id: 104, category: "Labor Estimation", type: "image", image: FlooPlan4 },
    { id: 105, category: "Cost Analysis", type: "image", image: FlooPlan5 },
    { id: 106, category: "Cost Analysis", type: "image", image: FlooPlan6 },
    { id: 107, category: "Material Takeoff", type: "image", image: FlooPlan7 },
    { id: 108, category: "Labor Estimation", type: "image", image: FlooPlan8 },
    { id: 109, category: "Cost Analysis", type: "image", image: FlooPlan9 },
    { id: 110, category: "Material Takeoff", type: "image", image: FlooPlan10 },
    // PDF sample for takeoff
    { id: 111, category: "Material Takeoff", type: "pdf", title: "Material Takeoff Report", thumbnail: FlooPlan2, pdfUrl: "https://www.w3.org/WAI/WCAG21/Techniques/pdf/PDF2.pdf" },
    { id: 112, category: "Cost Analysis", type: "pdf", title: "Cost Analysis Summary", thumbnail: FlooPlan5, pdfUrl: "https://www.w3.org/WAI/WCAG21/Techniques/pdf/PDF2.pdf" },
    // Video sample for takeoff
    { id: 113, category: "Labor Estimation", type: "video", title: "Takeoff Process Walkthrough", thumbnail: FlooPlan3, videoUrl: "https://www.w3schools.com/html/mov_bbb.mp4" },
  ];

  const activeProjects = serviceType === "drafting" ? draftingProjects : takeoffProjects;
  const activeCategories = serviceType === "drafting" ? draftingCategories : takeoffCategories;

  const filteredProjects =
    activeFilter === "All"
      ? activeProjects
      : activeProjects.filter((p) => p.category === activeFilter);

  const closeAllModals = () => {
    setSelectedProject(null);
    setSelectedPdf(null);
    setSelectedVideo(null);
    setSelected360(null);
  };

  const switchServiceType = (type: "drafting" | "takeoff") => {
    setServiceType(type);
    setActiveFilter("All");
    setSelectedProject(null);
    setSelectedPdf(null);
    setSelectedVideo(null);
    setSelected360(null);
  };

  const open360 = (project: Rendering360Project) => {
    setActive360Tab("south");
    setSelected360(project);
  };

  const viewLabels: { key: ViewDirection; label: string; icon: string }[] = [
    { key: "south", label: "South View", icon: "ri-arrow-down-line" },
    { key: "north", label: "North View", icon: "ri-arrow-up-line" },
    { key: "west", label: "West View", icon: "ri-arrow-left-line" },
    { key: "east", label: "East View", icon: "ri-arrow-right-line" },
  ];

  return (
    <div className="min-h-screen bg-white dark:bg-slate-900 transition-colors duration-300">
      <Header />
      <main>
        {/* ── Hero Section ─────────────────────────────────────────────────── */}
        <section className="relative py-20 bg-gradient-to-br from-[#dbcfbf]/30 to-white dark:from-slate-800/50 dark:to-slate-900 transition-colors duration-300">
          <div
            className="absolute inset-0 opacity-15"
            style={{
              backgroundImage: `url('${HeroImage}')`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          />
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#212026] dark:text-gray-100 mb-6 transition-colors duration-300">
              Our Portfolio
            </h1>
            <p className="text-xl md:text-2xl text-[#889d8f] dark:text-gray-300 max-w-4xl mx-auto transition-colors duration-300">
              Explore our projects across AutoCAD, Revit, Dialux, Floor Plans,
              and Line Diagrams
            </p>
          </div>
        </section>

        {/* ── Services Showcase Section ─────────────────────────────────────── */}
        <ServicesShowcaseSection />

        {/* ── Drafting / Takeoff Toggle ─────────────────────────────────────── */}
        <section className="py-10 bg-[#f8f5f1] dark:bg-slate-800/40 border-b border-[#dbcfbf]/30 dark:border-slate-700 transition-colors duration-300">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-7">
              <h2 className="text-2xl md:text-3xl font-bold text-[#212026] dark:text-gray-100 mb-2">
                Browse Our Work
              </h2>
              <p className="text-[#889d8f] dark:text-gray-400">
                Switch between our Drafting and Takeoff project portfolios
              </p>
            </div>

            {/* Toggle Pill */}
            <div className="flex justify-center mb-8">
              <div className="inline-flex bg-white dark:bg-slate-800 rounded-2xl p-1.5 shadow-md border border-[#dbcfbf]/40 dark:border-slate-700">
                <button
                  onClick={() => switchServiceType("drafting")}
                  className={`relative flex items-center gap-2.5 px-7 py-3 rounded-xl text-sm font-semibold transition-all duration-300 cursor-pointer ${serviceType === "drafting"
                    ? "bg-[#e18033] text-white shadow-lg"
                    : "text-[#889d8f] dark:text-gray-400 hover:text-[#212026] dark:hover:text-gray-200"
                    }`}
                >
                  <i className="ri-draft-line text-base" />
                  Drafting Services
                  {serviceType === "drafting" && (
                    <span className="ml-1 px-2 py-0.5 bg-white/25 rounded-full text-xs font-bold">
                      {draftingProjects.length}
                    </span>
                  )}
                </button>
                <button
                  onClick={() => switchServiceType("takeoff")}
                  className={`relative flex items-center gap-2.5 px-7 py-3 rounded-xl text-sm font-semibold transition-all duration-300 cursor-pointer ${serviceType === "takeoff"
                    ? "bg-[#0d9488] text-white shadow-lg"
                    : "text-[#889d8f] dark:text-gray-400 hover:text-[#212026] dark:hover:text-gray-200"
                    }`}
                >
                  <i className="ri-calculator-line text-base" />
                  Takeoff Services
                  {serviceType === "takeoff" && (
                    <span className="ml-1 px-2 py-0.5 bg-white/25 rounded-full text-xs font-bold">
                      {takeoffProjects.length}
                    </span>
                  )}
                </button>
              </div>
            </div>

            {/* Category Filters */}
            <div className="flex flex-wrap justify-center gap-2">
              {activeCategories.map((category) => (
                <button
                  key={category}
                  onClick={() => setActiveFilter(category)}
                  className={`px-5 py-2.5 rounded-full font-medium transition-all cursor-pointer whitespace-nowrap text-sm ${activeFilter === category
                    ? serviceType === "drafting"
                      ? "bg-[#e18033] text-white shadow-lg"
                      : "bg-[#0d9488] text-white shadow-lg"
                    : "bg-white dark:bg-slate-700/50 text-[#212026] dark:text-gray-200 hover:bg-[#dbcfbf]/40 dark:hover:bg-slate-600/50 border border-[#dbcfbf]/40 dark:border-slate-600"
                    }`}
                >
                  {category}
                </button>
              ))}
            </div>
            <div className="text-center mt-4">
              <p className="text-[#889d8f] dark:text-gray-300 text-sm">
                Showing {filteredProjects.length} item
                {filteredProjects.length !== 1 ? "s" : ""}
              </p>
            </div>
          </div>
        </section>

        {/* ── Portfolio Grid ────────────────────────────────────────────────── */}
        <section className="py-20 bg-white dark:bg-slate-900 transition-colors duration-300">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
              {filteredProjects.map((project) => {
                // ── PDF Card ──────────────────────────────────────────────
                if (project.type === "pdf") {
                  return (
                    <Card
                      key={project.id}
                      className="group overflow-hidden cursor-pointer bg-white dark:bg-slate-800 border-gray-200 dark:border-slate-700 transition-colors duration-300"
                      onClick={() => setSelectedPdf(project)}
                    >
                      <div className="relative h-64 bg-[#dbcfbf]/10 dark:bg-slate-700/30">
                        <img
                          src={project.thumbnail}
                          className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                          alt={project.title}
                        />
                        {/* Dark overlay on hover */}
                        <div className="absolute inset-0 bg-gradient-to-t from-[#212026]/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                        {/* PDF Badge */}
                        <div className="absolute top-4 left-4 flex items-center gap-1.5 px-3 py-1 bg-red-600 text-white text-xs font-bold rounded-full shadow-lg">
                          <i className="ri-file-pdf-line text-sm" />
                          PDF
                        </div>
                        {/* Category badge */}
                        <div className="absolute top-4 right-4 px-2 py-1 bg-[#212026]/70 text-white text-xs rounded-full">
                          {project.category}
                        </div>
                        {/* Hover CTA */}
                        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                          <div className="text-center text-white">
                            <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-2">
                              <i className="ri-file-pdf-line text-xl" />
                            </div>
                            <p className="text-sm font-medium">Open PDF</p>
                          </div>
                        </div>
                      </div>
                      <div className="p-3 bg-white dark:bg-slate-800 border-t border-gray-100 dark:border-slate-700">
                        <p className="text-sm font-medium text-[#212026] dark:text-gray-200 truncate">
                          {project.title}
                        </p>
                      </div>
                    </Card>
                  );
                }

                // ── 360° Rendering Card ───────────────────────────────────
                if (project.type === "rendering360") {
                  return (
                    <Card
                      key={project.id}
                      className="group overflow-hidden cursor-pointer bg-white dark:bg-slate-800 border-gray-200 dark:border-slate-700 transition-colors duration-300"
                      onClick={() => open360(project)}
                    >
                      <div className="relative h-64 bg-[#dbcfbf]/10 dark:bg-slate-700/30">
                        <img
                          src={project.image}
                          className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                          alt={project.title}
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-[#212026]/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                        {/* 360° Badge */}
                        <div className="absolute top-4 right-4 flex items-center gap-1 px-3 py-1.5 bg-[#e18033] text-white text-xs font-extrabold rounded-full shadow-lg tracking-wider">
                          <i className="ri-360-line text-sm" />
                          360°
                        </div>
                        {/* Category */}
                        <div className="absolute top-4 left-4 px-3 py-1 bg-[#212026]/70 text-white text-xs font-medium rounded-full">
                          {project.category}
                        </div>
                        {/* Hover CTA */}
                        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                          <div className="text-center text-white">
                            <div className="w-12 h-12 bg-[#e18033] rounded-full flex items-center justify-center mx-auto mb-2">
                              <i className="ri-360-line text-xl" />
                            </div>
                            <p className="text-sm font-medium">View All Angles</p>
                          </div>
                        </div>
                      </div>
                      <div className="p-3 bg-white dark:bg-slate-800 border-t border-gray-100 dark:border-slate-700">
                        <p className="text-sm font-medium text-[#212026] dark:text-gray-200 truncate">
                          {project.title}
                        </p>
                      </div>
                    </Card>
                  );
                }

                // ── Video Card ────────────────────────────────────────────
                if (project.type === "video") {
                  return (
                    <Card
                      key={project.id}
                      className="group overflow-hidden cursor-pointer bg-white dark:bg-slate-800 border-gray-200 dark:border-slate-700 transition-colors duration-300"
                      onClick={() => setSelectedVideo(project)}
                    >
                      <div className="relative h-64 bg-[#dbcfbf]/10 dark:bg-slate-700/30">
                        <img
                          src={project.thumbnail}
                          className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                          alt={project.title}
                        />
                        {/* Dark overlay on hover */}
                        <div className="absolute inset-0 bg-gradient-to-t from-[#212026]/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                        {/* Video Badge */}
                        <div className="absolute top-4 left-4 flex items-center gap-1.5 px-3 py-1 bg-violet-600 text-white text-xs font-bold rounded-full shadow-lg">
                          <i className="ri-play-circle-line text-sm" />
                          VIDEO
                        </div>
                        {/* Category badge */}
                        <div className="absolute top-4 right-4 px-2 py-1 bg-[#212026]/70 text-white text-xs rounded-full">
                          {project.category}
                        </div>
                        {/* Play button hover */}
                        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                          <div className="text-center text-white">
                            <div className="w-14 h-14 bg-violet-600 rounded-full flex items-center justify-center mx-auto mb-2 shadow-xl">
                              <i className="ri-play-fill text-2xl ml-0.5" />
                            </div>
                            <p className="text-sm font-medium">Play Video</p>
                          </div>
                        </div>
                      </div>
                      <div className="p-3 bg-white dark:bg-slate-800 border-t border-gray-100 dark:border-slate-700">
                        <p className="text-sm font-medium text-[#212026] dark:text-gray-200 truncate">
                          {project.title}
                        </p>
                      </div>
                    </Card>
                  );
                }

                // ── Standard Image Card ───────────────────────────────────
                return (
                  <Card
                    key={project.id}
                    className="group overflow-hidden cursor-pointer bg-white dark:bg-slate-800 border-gray-200 dark:border-slate-700 transition-colors duration-300"
                    onClick={() =>
                      setSelectedProject(
                        selectedProject === project.id ? null : project.id
                      )
                    }
                  >
                    <div className="relative h-64 bg-[#dbcfbf]/10 dark:bg-slate-700/30">
                      <img
                        src={project.image}
                        className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-[#212026]/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                      <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <div className="text-center text-white">
                          <div className="w-12 h-12 bg-[#e18033] rounded-full flex items-center justify-center mx-auto mb-2">
                            <i className="ri-eye-line text-xl" />
                          </div>
                          <p className="text-sm font-medium">View Project</p>
                        </div>
                      </div>
                      <div className="absolute top-4 left-4 px-3 py-1 bg-[#e18033] text-white text-xs font-medium rounded-full">
                        {project.category}
                      </div>
                      {/* Disclaimer badge with tooltip */}
                      {project.disclaimer && (
                        <div className="absolute bottom-3 right-3 group/disclaimer z-10" onClick={(e) => e.stopPropagation()}>
                          <div className="flex items-center gap-1.5 px-2.5 py-1 bg-amber-500/90 text-white text-[11px] font-semibold rounded-full cursor-help shadow-md backdrop-blur-sm">
                            <i className="ri-error-warning-line text-xs" />
                            {project.disclaimer.label}
                          </div>
                          {/* Tooltip */}
                          <div className="absolute bottom-full right-0 mb-2 w-60 px-3 py-2.5 bg-[#212026] text-white text-xs leading-relaxed rounded-xl shadow-xl opacity-0 group-hover/disclaimer:opacity-100 pointer-events-none transition-opacity duration-200 z-20">
                            {project.disclaimer.description}
                            <div className="absolute top-full right-4 w-2.5 h-2.5 bg-[#212026] rotate-45 -mt-1.5" />
                          </div>
                        </div>
                      )}
                    </div>
                    {/* Image modal */}
                    {selectedProject === project.id && (
                      <div
                        className="fixed inset-0 bg-[#212026]/80 dark:bg-black/90 flex items-center justify-center z-50 p-4"
                        onClick={closeAllModals}
                      >
                        <div
                          className="bg-white dark:bg-slate-800 rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-auto"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div className="relative">
                            <img
                              src={project.image}
                              className="w-full h-full object-cover object-top rounded-t-2xl"
                            />
                            <button
                              onClick={closeAllModals}
                              className="absolute top-4 right-4 w-10 h-10 bg-white/20 hover:bg-[#e18033]/80 rounded-full flex items-center justify-center cursor-pointer transition-colors duration-300"
                            >
                              <i className="ri-close-line text-white text-xl" />
                            </button>
                            <div className="absolute top-4 left-4 px-3 py-1 bg-[#e18033] text-white text-sm font-medium rounded-full">
                              {project.category}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </Card>
                );
              })}
            </div>
          </div>
        </section>

        {/* ── Video Popup Modal ─────────────────────────────────────────────── */}
        {selectedVideo && (
          <div
            className="fixed inset-0 bg-black/90 flex items-center justify-center z-50 p-4"
            onClick={() => setSelectedVideo(null)}
          >
            <div
              className="bg-white dark:bg-slate-800 rounded-2xl w-full max-w-4xl flex flex-col overflow-hidden shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Header */}
              <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 dark:border-slate-700 flex-shrink-0">
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 bg-violet-600 rounded-lg flex items-center justify-center">
                    <i className="ri-play-circle-line text-white text-lg" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#212026] dark:text-gray-100 text-base">
                      {selectedVideo.title}
                    </h3>
                    <p className="text-xs text-[#889d8f] dark:text-gray-400">
                      {selectedVideo.category}
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <a
                    href={selectedVideo.videoUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-4 py-2 bg-[#e18033] text-white text-sm font-medium rounded-lg hover:bg-[#c96a1a] transition-colors flex items-center gap-1.5"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <i className="ri-external-link-line" />
                    Open in New Tab
                  </a>
                  <button
                    onClick={() => setSelectedVideo(null)}
                    className="w-9 h-9 bg-gray-100 dark:bg-slate-700 hover:bg-red-100 dark:hover:bg-red-900/30 rounded-lg flex items-center justify-center cursor-pointer transition-colors"
                  >
                    <i className="ri-close-line text-[#212026] dark:text-gray-200 text-lg" />
                  </button>
                </div>
              </div>
              {/* Video Player */}
              <div className="bg-black">
                <video
                  key={selectedVideo.videoUrl}
                  src={selectedVideo.videoUrl}
                  controls
                  autoPlay
                  className="w-full max-h-[70vh] outline-none"
                  style={{ display: "block" }}
                >
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div>
        )}

        {/* ── PDF Popup Modal ───────────────────────────────────────────────── */}
        {selectedPdf && (
          <div
            className="fixed inset-0 bg-black/85 flex items-center justify-center z-50 p-4"
            onClick={() => setSelectedPdf(null)}
          >
            <div
              className="bg-white dark:bg-slate-800 rounded-2xl w-full max-w-5xl h-[90vh] flex flex-col overflow-hidden shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Header */}
              <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 dark:border-slate-700 flex-shrink-0">
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 bg-red-600 rounded-lg flex items-center justify-center">
                    <i className="ri-file-pdf-line text-white text-lg" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#212026] dark:text-gray-100 text-base">
                      {selectedPdf.title}
                    </h3>
                    <p className="text-xs text-[#889d8f] dark:text-gray-400">
                      {selectedPdf.category}
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <a
                    href={selectedPdf.pdfUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-4 py-2 bg-[#e18033] text-white text-sm font-medium rounded-lg hover:bg-[#c96a1a] transition-colors flex items-center gap-1.5"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <i className="ri-external-link-line" />
                    Open in New Tab
                  </a>
                  <button
                    onClick={() => setSelectedPdf(null)}
                    className="w-9 h-9 bg-gray-100 dark:bg-slate-700 hover:bg-red-100 dark:hover:bg-red-900/30 rounded-lg flex items-center justify-center cursor-pointer transition-colors"
                  >
                    <i className="ri-close-line text-[#212026] dark:text-gray-200 text-lg" />
                  </button>
                </div>
              </div>
              {/* PDF iframe */}
              <div className="flex-1 bg-gray-100 dark:bg-slate-900">
                <iframe
                  src={selectedPdf.pdfUrl}
                  className="w-full h-full border-0"
                  title={selectedPdf.title}
                />
              </div>
            </div>
          </div>
        )}

        {/* ── 360° Rendering Popup Modal ────────────────────────────────────── */}
        {selected360 && (
          <div
            className="fixed inset-0 bg-black/85 flex items-center justify-center z-50 p-4"
            onClick={() => setSelected360(null)}
          >
            <div
              className="bg-white dark:bg-slate-800 rounded-2xl w-full max-w-5xl max-h-[92vh] flex flex-col overflow-hidden shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Header */}
              <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 dark:border-slate-700 flex-shrink-0">
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 bg-[#e18033] rounded-lg flex items-center justify-center">
                    <i className="ri-360-line text-white text-lg" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#212026] dark:text-gray-100 text-base">
                      {selected360.title}
                    </h3>
                    <p className="text-xs text-[#889d8f] dark:text-gray-400">
                      360° Rendering — All Directional Views
                    </p>
                  </div>
                </div>
                <button
                  onClick={() => setSelected360(null)}
                  className="w-9 h-9 bg-gray-100 dark:bg-slate-700 hover:bg-red-100 dark:hover:bg-red-900/30 rounded-lg flex items-center justify-center cursor-pointer transition-colors"
                >
                  <i className="ri-close-line text-[#212026] dark:text-gray-200 text-lg" />
                </button>
              </div>

              {/* Tab Bar */}
              <div className="flex border-b border-gray-200 dark:border-slate-700 flex-shrink-0 bg-gray-50 dark:bg-slate-900/50">
                {viewLabels.map((v) => (
                  <button
                    key={v.key}
                    onClick={() => setActive360Tab(v.key)}
                    className={`flex-1 flex items-center justify-center gap-2 py-3.5 text-sm font-semibold transition-all duration-200 cursor-pointer border-b-2 ${active360Tab === v.key
                      ? "border-[#e18033] text-[#e18033] bg-white dark:bg-slate-800"
                      : "border-transparent text-[#889d8f] dark:text-gray-400 hover:text-[#212026] dark:hover:text-gray-200 hover:bg-white/60 dark:hover:bg-slate-700/40"
                      }`}
                  >
                    <i className={`${v.icon} text-base`} />
                    <span className="hidden sm:inline">{v.label}</span>
                    <span className="sm:hidden capitalize">{v.key}</span>
                  </button>
                ))}
              </div>

              {/* Rendering Image */}
              <div className="flex-1 overflow-hidden bg-[#212026] relative min-h-0">
                <img
                  key={active360Tab}
                  src={selected360.views[active360Tab]}
                  alt={`${active360Tab} view`}
                  className="w-full h-full object-contain animate-fade-in"
                  style={{ animation: "fadeIn 0.3s ease-in-out" }}
                />
                {/* Direction label overlay */}
                <div className="absolute bottom-4 left-1/2 -translate-x-1/2 px-4 py-2 bg-black/60 text-white text-sm font-semibold rounded-full backdrop-blur-sm flex items-center gap-2">
                  <i className={`${viewLabels.find((v) => v.key === active360Tab)?.icon} text-[#e18033]`} />
                  {viewLabels.find((v) => v.key === active360Tab)?.label}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ── Featured Projects Section ─────────────────────────────────────── */}
        <PortfolioSectionA />

        {/* ── Call-to-Action Section ────────────────────────────────────────── */}
        <section className="py-20 bg-[#e18033] dark:bg-[#d16f29] transition-colors duration-300">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
              Want similar results for your project?
            </h2>
            <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
              Let our expert team deliver the same level of precision and
              quality for your next engineering or design project
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="/contact">
                <Button
                  variant="outline"
                  size="lg"
                  className="border-white text-white hover:bg-white hover:text-black dark:border-gray-300 dark:hover:bg-gray-300 dark:hover:text-slate-900 transition-all duration-300"
                >
                  <div className="w-5 h-5 flex items-center justify-center mr-2">
                    <i className="ri-phone-line" />
                  </div>
                  Contact Us
                </Button>
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />

      {/* ── Fade-in keyframe ─────────────────────────────────────────────────── */}
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: scale(0.98); }
          to   { opacity: 1; transform: scale(1); }
        }
      `}</style>
    </div>
  );
}
